module.exports = __webpack_public_path__ + "static/media/itconic.ad301f42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/itconic.svg
// module id = 544
// module chunks = 49